import { render, staticRenderFns } from "./ViewerVideo.vue?vue&type=template&id=83074618&scoped=true&"
import script from "./ViewerVideo.vue?vue&type=script&lang=js&"
export * from "./ViewerVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83074618",
  null
  
)

export default component.exports